const isHeading = (p) => p.startsWith("## ") || (p.length < 70 && !/[.!?,;:"”)*]$/.test(p) && !/^[•\-–|]/.test(p) && !/^\d+\.\s/.test(p));
const isBullet = (p) => /^[•\-–]\s/.test(p);
const isNum = (c) => c.length < 24 && /^[+\-−]?(US\$|GH¢|[£$€])?[\d.,]+/.test(c);
const isNumbered = (p) => /^\d+\.\s/.test(p);

export const Inline = ({ text }) =>
  text.split(/(\*\*[^*]+\*\*|\*[^*\s][^*]*\*)/g).map((s, i) => (s.startsWith("**") && s.endsWith("**") ? <strong key={i}>{s.slice(2, -2)}</strong>
    : s.length > 2 && s.startsWith("*") && s.endsWith("*") ? <em key={i}>{s.slice(1, -1)}</em> : s));

const Table = ({ src }) => {
  const rows = src.split("\n").filter((r) => !/^\|\s*-/.test(r)).map((r) => r.replace(/^\||\|$/g, "").split("|").map((c) => c.trim()));
  const [head, ...body] = rows;
  const numCol = head.map((_, j) => j > 0 && body.every((r) => isNum(r[j] || "")));
  return (
    <div className="article-table" data-testid="article-table">
      <table>
        <thead><tr>{head.map((h, i) => <th key={i} className={numCol[i] ? "num" : ""}>{h}</th>)}</tr></thead>
        <tbody>{body.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} className={`${/^[+-]\d/.test(c) ? (c.startsWith("+") ? "chg-up" : "chg-down") : ""} ${numCol[j] ? "num" : ""}`}><Inline text={c} /></td>)}</tr>)}</tbody>
      </table>
    </div>
  );
};

export const Body = ({ paras, testid = "article-body" }) => {
  const out = [];
  let list = [];
  let kind = null;
  let dropped = false;
  const flush = (k) => {
    if (list.length) out.push(kind === "ol" ? <ol key={`ol-${k}`}>{list}</ol> : <ul key={`ul-${k}`}>{list}</ul>);
    list = []; kind = null;
  };
  paras.forEach((p, i) => {
    const k = isBullet(p) ? "ul" : isNumbered(p) ? "ol" : null;
    if (k) {
      if (kind && kind !== k) flush(i);
      kind = k;
      return list.push(<li key={i}><Inline text={p.replace(/^([•\-–]|\d+\.)\s*/, "")} /></li>);
    }
    flush(i);
    if (p.startsWith("|")) return out.push(<Table key={i} src={p} />);
    if (isHeading(p)) return out.push(<h2 key={i}>{p.replace(/^#{2,3} /, "")}</h2>);
    out.push(<p key={i} className={!dropped ? "dropcap" : ""}><Inline text={p} /></p>);
    dropped = true;
  });
  flush("end");
  return <div className="article-body" data-testid={testid}>{out}</div>;
};
